import { Partner } from "Store/partners/partnerInterfaces";
import { stbTheme } from "./Storebrand/themeStorebrand";

export const allThemes = {
  stb: {
    id: Partner.STOREBRAND,
    ...stbTheme,
  },
  afag: {
    id: Partner.AFAG,
    ...stbTheme,
  },
  legeforeningen: {
    id: Partner.LEGEFORENINGEN,
    ...stbTheme,
  },
  tannlegeforeningen: {
    id: Partner.TANNLEGEFORENINGEN,
    ...stbTheme,
  },
  veterinarene: {
    id: Partner.VETERINARENE,
    ...stbTheme,
  },
  econa: {
    id: Partner.ECONA,
    ...stbTheme,
  },
  naturviterne: {
    id: Partner.NATURVITERNE,
    ...stbTheme,
  },
  lektorlaget: {
    id: Partner.LEKTORLAGET,
    ...stbTheme,
  },
  psykologforeningen: {
    id: Partner.PSYKOLOGFORENINGEN,
    ...stbTheme,
  },
  samfunnsviterne: {
    id: Partner.SAMFUNNSVITERNE,
    ...stbTheme,
  },
  samfunnsokonomene: {
    id: Partner.SAMFUNNSOKONOMENE,
    ...stbTheme,
  },
  coop: {
    id: Partner.COOP,
    ...stbTheme,
  },
  danskebank: {
    id: Partner.DANSKE_BANK,
    ...stbTheme,
    showIllustration: false,
  },
  huseierne: {
    id: Partner.HUSEIERNE,
    ...stbTheme,
  },
};
